import { Form } from "antd";
import UploadImages from "components/UploadImages";

/** ช่องอัปโหลดโลโก้กิจการ — ค่าที่ได้ไปลง factory.image ตอนบันทึก */
const SettingAvatar = () => (
  <Form.Item
    name="image"
    rules={[{ required: true, message: "กรุณาเพิ่มโลโก้กิจการ" }]}
  >
    <UploadImages maximumUploadItems={1} />
  </Form.Item>
);

export default SettingAvatar;
